import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DEFAULT_STATUS_COLOR_SCHEME, StatusColorScheme } from './status.const';

@Component({
  selector: 'mtm-status-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './status-badge.component.html',
  styleUrl: './status-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusBadgeComponent {
  readonly label = input<string>('');
  readonly colorScheme = input<StatusColorScheme>(DEFAULT_STATUS_COLOR_SCHEME);

  readonly hostStyles = computed(() => {
    const cs = this.colorScheme();
    return {
      background: cs.bg,
      borderColor: cs.border,
    };
  });

  readonly labelStyles = computed(() => ({ color: this.colorScheme().text }));
}
